import useSWR from 'swr'
import API from 'utils/api'
import { useToken } from 'app/hooks'

const KEY = '/auth/devices'

export type DeviceServiceKey = 'goms' | 'want'

export interface UserDevice {
	id: number
	serviceKey: DeviceServiceKey
	sessionToken: string
	deviceId: string | null
	deviceName: string | null
	userAgent: string | null
	ipAddress: string | null
	loginAt: string | null
	lastActivity: string | null
	isActive: boolean
	revokedAt?: string | null
}

export interface UserDevicesResponse {
	devices: UserDevice[]
}

export function useUserDevices() {
	const { data: token } = useToken()

	const { data, error, isValidating, mutate } = useSWR<UserDevicesResponse>(
		token ? KEY : null,
		async (url: string) => {
			const response = await API.get(url, token + '', {})
			return response.result || { devices: [] }
		},
		{ revalidateOnFocus: true }
	)

	const isLoading = !data && !error
	const devices = data?.devices ?? []

	return {
		devices,
		error,
		isLoading,
		isValidating,
		mutate,
	}
}

export default useUserDevices
